import React from 'react';
import { Box } from '@mui/material';
import ConsultaChat from '../components/Consultas/ConsultaChat';
import { useApi } from '../hooks/useApi';
import type { ConsultaAnalizarRequest, ModuloConsultaIa } from '../types/consultasIa';

const TITLES: Record<ModuloConsultaIa, string> = {
    ventas: 'Consulta inteligente — Ventas',
    compras: 'Consulta inteligente — Compras',
    inventario: 'Consulta inteligente — Inventario',
    tesoreria: 'Consulta inteligente — Tesorería',
};

interface ConsultaIaModuloPageProps {
    modulo: ModuloConsultaIa;
}

const ConsultaIaModuloPage: React.FC<ConsultaIaModuloPageProps> = ({ modulo }) => {
    const api = useApi();

    const handleConsulta = async (consulta: ConsultaAnalizarRequest): Promise<string> => {
        try {
            const response = await api.post('/api/Consultas/analizar', consulta);
            return response.data.respuesta as string;
        } catch (error: unknown) {
            const err = error as { response?: { data?: { error?: string; message?: string } } };
            if (err.response?.data) {
                const d = err.response.data;
                throw new Error(
                    (typeof d.error === 'string' ? d.error : null) ||
                        (typeof d.message === 'string' ? d.message : null) ||
                        'Error al procesar la consulta'
                );
            }
            throw error;
        }
    };

    return (
        <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', p: { xs: 2, sm: 3 } }}>
            <ConsultaChat titulo={TITLES[modulo]} modulo={modulo} onConsulta={handleConsulta} />
        </Box>
    );
};

export default ConsultaIaModuloPage;
